var map = {
	"./emotion-correct-afraid.png": 31416,
	"./emotion-correct-angry.png": 63742,
	"./emotion-correct-happy.png": 49535,
	"./emotion-correct-neutral.png": 64652,
	"./emotion-correct-sad.png": 17361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22813;